module.exports = __webpack_public_path__ + "static/media/diagram-emotional-distress-process-explained@3x.21701143.png";